import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import ChildCard from '../../../../components/shared/ChildCard';
import CusInput from '../../../../components/material-ui/CusInput';
import CusButton from '../../../../components/material-ui/CusButton';
import CusTooltip from '../../../../components/material-ui/CusTooltip';
import { useTranslation } from 'react-i18next';
import CusLink from '../../../../components/material-ui/CusLink';

export default function CreateReferral({ createReferralHandler, groupId }) {
  const { t } = useTranslation();

  const [comment, setComment] = useState('');
  const [staticParam, setStaticParam] = useState('');

  const onCreateClick = () => {
    createReferralHandler(comment, staticParam);
    setComment('');
    setStaticParam('');
  };

  return (
    <ChildCard title={t('Create a ref link')}>
      <Stack display={'flex'} flexDirection={'column'} gap={1}>
        <CusInput
          label={'Comment (not visible to the player)'}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <CusInput
          label={'Add static parameters to a link'}
          value={staticParam}
          onChange={(e) => setStaticParam(e.target.value)}
          tooltipText={
            <Typography>
              {t(
                'The transmitted parameters will be correctly encoded for the website link and specially for the Telegram bot link.'
              )}
              <br />
              <br />
              {t('Add dynamic parameters manually,')} <b>{t('NOT IN THIS FIELD.')}</b>{' '}
              {t(
                'Simply add them to the URL, properly encoded for the GET request to the website and/or the bot link, using DOUBLE underscores (instead of &). Do not use special characters in the request, otherwise Telegram will truncate the string.'
              )}
            </Typography>
          }
        />
        <Stack display={'flex'} gap={0.5} flexDirection={'row'} alignItems={'center'}>
          <CusButton text="Create a ref link" onClick={onCreateClick} />
          <CusTooltip
            text={
              <Typography variant="body1">
                {
                  <>
                    {t(
                      'You can add any dynamic GET parameters to the created ref. link, and they will be passed back in the postback call.'
                    )}{' '}
                    {`\n`} {t('For example, you can add to the referral link for the site')}{' '}
                    <b>click_id=123&action_id=456 </b>{' '}
                    {t('and this data will be further transmitted in a postback request.')} {`\n`}
                    {t(
                      'Also for ref. TG bot links can add GET parameters, but for coding instead'
                    )}{' '}
                    <b>&</b> {t('need to use')} <b>{t('double underline.')}</b>
                    {`\n`}
                    {t('For example')} <b>click_id=123__action_id=456</b>
                    {`\n`}
                    <b>
                      {t(
                        'Do not use special characters in the referral link, including in the transmitted data, otherwise Telegram will cut the line.'
                      )}
                    </b>
                  </>
                }
              </Typography>
            }
          />
          <CusLink text={'Postbacks'} to={`/affiliate/${groupId}/postbacks`} ml={'auto'} />
        </Stack>
      </Stack>
    </ChildCard>
  );
}
